export const TechEvents = {
    // Tenet
    "tenet": {
        name: "Tenet",
        imgName:"Saj.jpeg",
        refName: "tenet",
        about: `TENET is a challenge where the participants have to identify and resolve bugs, thus making the system unproblematic. Logical thinking of the programmer is tested through this event where the participant has to come up with unique solutions to produce an expected output.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
            "Date:March 26th",
            "Time:2pm"
        ],

        contact: [
            {
                name: "Arshak Shan ",
                mobile: "  8129583239"
            },
            {
                name: "Shruthi S ",
                mobile: "  7358325784"
            },
            {
                name: "Darrshana R ",
                mobile: "  9123590345"
            },
            {
                name: "Shakkthi ",
                mobile: "  7299084122"
            },
        ],

        sponsor: "YouthInU",

        rules: [
            "This event is for individual participants only.",
            "Candidates involved in any kind of malpractice will be disqualified immediately",
            "Marks will be provided based on the efficiency of the solution and the number of test cases passed (debugging and reverse coding).",
            "There will be no negative marking for MCQs.",
            "Decisions made by the administrators will be final",
            "Participants must ensure that they have laptop with good internet connectivity for their convenience",
            "Participants must ensure that they have microsoft account"
        ],

        rounds: {
            number: 3,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "Participants will be given 25 mins to answer MCQs which is a combination of technical (OS,DBMS,OOPS..) and general aptitude questions."
                },
                {
                    title: "Semi-Finals",
                    description: "A debugging round where candidates have to find the logical and syntactical errors in the given code snippets and run the correct code  in the platform provided for various test cases. (30 minutes)"
                },
                {
                    title: "Finals",
                    description: "A reverse coding round where candidates have to analyze the given input-output sequences and decode the logic behind it. Write a code snippet that will generate the corresponding input output pattern. (30 mins)"
                },
                {   title : "Prize",
                    description: "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
                }
            ]
        },
        registration: true,
        purpose: "EVENTS"
    },

    // Novice
    "novice-init": {
        name: "Novice.init()",
        refName: "novice",
        about: `Novice.init() is an exclusive event for the first year students of various colleges. It provides scope for the young minds to explore the coding world and to assess their logical reasoning abilities. This event introduces newbies to the technical contests.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
            "Date:March 26th",
            "Time:9:30am"
        ],

        contact: [
            {
                name: "Gabrio Mascarnas A",
                mobile: "9488394416"
            },
            {
                name: "Vasanthakumar R",
                mobile: "6379841032"
            },
            {
                name: "Sabhari P",
                mobile: "8220265629"
            }
        ],

        // sponsor: "",

        rules: [
            "Students other than first years are not allowed to take this event.",
            "Participants involved in any kind of malpractice will be disqualified.",
            "Marks will be provided based on the difficulty of the questions.",
            "Decisions made by the administrators will be final.",
            "Participants must ensure that they have laptop with good internet connectivity for their convenience.",
            "Participants must ensure that they have microsoft account."
        ],

        rounds: {
            number: 3,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "Participants will be given 45 minutes to answer MCQs on puzzles, basics of programming and verbal reasoning."
                },
                {
                    title: "Semi-Finals",
                    description: "Focuses on logical reasoning, finding the output of a program, completing the code and puzzles (45 minutes)"
                },
                {
                    title: "Finals",
                    description: "Concentrates on programming, code debugging, algorithm, rapid-fire questions on puzzles (45 minutes)"
                },
                {   title : "Prize",
                    description: "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
                }
            ]
        },
        registration: true,
        purpose: "EVENTS"
    },

    // Code for Crown - OLPC
    "code-for-crown-olpc": {
        imgName:"code-for-crown_sponsor1.jpeg",
        name: "Code for Crown - OLPC",
        refName: "code-for-crown",
        about: `Wallow yourself in the realm of coding. Experience a myriad of challenges. Come, conflate your ideas to deal with the conundrums and become the hegemonic coder.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
            "Date:March 26th",
            "Time:11am"
        ],

        /*contact: [

        ],*/

        sponsor: "Amazon",

        rules: [
            "This event is for individual participants only.",
            
            "There will be no negative marking for MCQs.",
            "Participants are allowed to use any one of the following programming languages for the coding rounds (C, C++, Java, Python3)",
            "Participants found guilty are not allowed to proceed with the competition.",
            "Participants must ensure that they have laptop with good internet connectivity for their convenience",
            "Participants must ensure that they have microsoft account."
        ],

        rounds: {
            number: 2,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "The participants are expected to answer a set of MCQs and a few standard coding questions." 

                },
                {
                    title: "Finals",
                    description: "Candidates must answer a few coding questions"
                },
                {   title : "Prize",
                    description: "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
                }
            ]
        },
        registration: true,
        purpose: "EVENTS"
    },

    // X-Domain Combat
    "x-domain-combat": {
        imgName:"Saj.jpeg",
        name: "X-Domain Combat",
        refName: "x-domain-combat",
        about: `X - Domain Combat mainly focuses on the sound knowledge and solid familiarity of the participants in 3 known topics DBMS, Networks and Operating Systems.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
            "Date:March 26th",
            "Time:2pm"
        ],

        contact: [
            {
                name: "Aparna G",
                mobile: "8903570838"
            },
            {
                name: "Nidya M",
                mobile: "9003854208"
            },
            {
                name: "Thivyha Siv",
                mobile: "6383645287"
            },
            {
                name: "Sarikaa S",
                mobile: "9487433066"
            },
        ],

        sponsor: "YouthInU",

        rules: [
            "This event allows only individual participants.",
            "The participants are not allowed to use any other sources. They can access only the exam platform and the MS Teams meet.",
            "Participants involved in any kind of malpractice will be disqualified immediately.",
            "Top performing participants in the first round will qualify for the final round.",
            "Decisions made by the administrators will be final",
        ],

        rounds: {
            number: 2,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "Participants will have 30 minutes to steer through the quiz and solve the 45 questions. The questions will be MCQ based on the 3 topics."
                },
                {
                    title: "Finals",
                    description: "Only those participants who cleared the cut-off in the Prelims round are qualified. This written round consists of 25 questions to answer the questions in 45 minutes which requires a logical thought process to solve the vexed questions and crunchers."
                },
                {   title : "Prize",
                    description: "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
                }
            ]
        },
        registration: true,
        purpose: "EVENTS"
    }

}

